// Short, fixed session ID for the terminal flavor in the smart-link header.
// Excluded chars: I, O, 0, 1 (ambiguous in the dot-matrix aesthetic).

export const SESSION_ID_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';

export function makeSessionId(rand: () => number = Math.random): string {
  let s = '';
  for (let i = 0; i < 6; i++) {
    s += SESSION_ID_ALPHABET[Math.floor(rand() * SESSION_ID_ALPHABET.length)];
  }
  return s;
}
